var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('card', {
    staticClass: "cod-help padding-bottom-3x mb-1 p-3 py-md-3"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('h2', {
    staticClass: "mb-4 text-center font-weight-light"
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")]), _c('img', {
    staticClass: "img-fluid mb-3 mr-2",
    attrs: {
      "src": _vm.iconLink,
      "alt": "Assistance icon",
      "height": "50px",
      "loading": "lazy"
    }
  }), _c('a', {
    staticClass: "btn btn-f2m btn-lg",
    attrs: {
      "href": 'tel:' + _vm.btnLink,
      "data-qa": "car-on-demand-order.help.call-us.text"
    }
  }, [_vm._v(" " + _vm._s(_vm.btnText) + " ")])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }